module.exports = __webpack_public_path__ + "static/media/sidewalk_labs.a5bee6c8.jpg";